import { render } from "./BaseHtmlCodeEditor.vue?vue&type=template&id=58163d86&scoped=true"
import script from "./BaseHtmlCodeEditor.vue?vue&type=script&lang=ts"
export * from "./BaseHtmlCodeEditor.vue?vue&type=script&lang=ts"

import "./BaseHtmlCodeEditor.vue?vue&type=style&index=0&id=58163d86&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-58163d86"

export default script